export const NumberFormats = Object.freeze({
  BINARY_RE: /^[Bb][01]+$/,
  DECIMAL_RE: /^#(0|[+-]?[1-9][0-9]*)$/,
  EXPONENT_RE: /^(0|[1-9][0-9])*$/,
  HEXADECIMAL_RE: /^0?[Xx][0-9a-fA-F]+$/,
  FLOATING_POINT_RE: /^[-+]?(0|([1-9][0-9]*))?(\.[0-9]+)?$/
})



// WEBPACK FOOTER //
// ./src/util/constants.js